module.exports = __webpack_public_path__ + "static/img/keHuSwiper9.439bb96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keHuSwiper9.png
// module id = iEc3
// module chunks = 2